import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StatoOrdine } from 'src/app/model/ordini/Ordine';
import { FaseStandard } from 'src/app/model/ordini/PosizioneFasi';
import { ServiceRespone } from 'src/app/model/serviceResponse';
import { Utente } from 'src/app/model/utente/utente';

import { msConfig } from 'src/app/services/ms-config';
import { AppConstants } from 'src/environments/constants';
import { CommonUtils } from 'src/utils/CommonUtils';

import { IOrdiniService } from './IOrdiniService';


@Injectable({
  providedIn: 'root'
})
export class OrdiniService implements IOrdiniService {

  constructor(private http: HttpClient) { }


  getQuantitaSvincolataPerPosizione(posizioneSelezionata: number): Observable<ServiceRespone> {
    let url = msConfig['ms-svincoli']  + AppConstants.PATH_QUANTITA_SVINCOLATA
    let params: any = {};
    params.idPosizione = posizioneSelezionata
    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }
  setIspettoreSnam(idOrdine: number, idIspettoreSnam: number): Observable<ServiceRespone> {
    let url = msConfig['ms-ordini'] + AppConstants.PATH_ORDINI + '/' + idOrdine + AppConstants.PATH_SET_ISPETTORE_SNAM
    let params: any = {};
    params.idIspettoreSnam = idIspettoreSnam
    return this.http
      .put(url, {}, params = {params})
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }
  avanzamentoFase(idFase: number, progresso: number): Observable<ServiceRespone> {
    let url = msConfig['ms-ordini'] + AppConstants.PATH_FASI + '/' + idFase + AppConstants.PATH_PROGRESSO_FASE
    let params: any = {};
    params.progresso = progresso
    return this.http
      .put(url, {}, params = {params})
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }

  setUtentiOrdine(idOrdine: number, idUtenteDaAggiungere: number, tipoUtente: string, idPosizioni: Array<number>, disableSelect: boolean): Observable<ServiceRespone> {
    let url = msConfig['ms-ordini'] + AppConstants.PATH_ORDINI + '/' + idOrdine + AppConstants.PATH_SET_UTENTI_ORDINE
    let params: any = {};
    params.idUtenteDaAggiungere = CommonUtils.isNotNullOrUndefined(idUtenteDaAggiungere) ? idUtenteDaAggiungere : []
    params.tipoUtente = tipoUtente
    params.idPosizioni = CommonUtils.isNotNullOrUndefined(idPosizioni) ? idPosizioni : []
    params.isDeleteUtente = disableSelect
    return this.http
      .put(url, {}, params = {params})
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))

  }

    setUtentiOrdineMassivo(idUtenteDaAggiungere: number, tipoUtente: string, idOrdini: Array<number>, disableSelect: boolean): Observable<ServiceRespone> {
   const url = msConfig['ms-ordini'] + AppConstants.PATH_ORDINI + AppConstants.PATH_SET_UTENTI_ORDINE_MASSIVO;
    let params: any = {};
    params.idUtenteDaAggiungere = CommonUtils.isNotNullOrUndefined(idUtenteDaAggiungere) ? idUtenteDaAggiungere : []
    params.tipoUtente = tipoUtente
    params.idOrdini = CommonUtils.isNotNullOrUndefined(idOrdini) ? idOrdini : []
    params.isDeleteUtente = disableSelect
    return this.http
      .put(url, {}, params = {params})
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))

  }
  setHashtagPosizione(idPosizione: number, hashtag: string): Observable<ServiceRespone> {
    let url = msConfig['ms-ordini'] + AppConstants.PATH_POSIZIONI + AppConstants.PATH_SET_HASHTAG + '/' + idPosizione
    let params: any = {};
    params.hashtag = hashtag
    return this.http
      .get(url, params = {params})
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }

  setPrioritaOrdine(idPosizione: number): Observable<boolean> {
    let url = msConfig['ms-ordini'] + AppConstants.PATH_POSIZIONI + '/' + idPosizione + '/setPriorita' ;
    return this.http
      .put(url,{})
      .pipe(map((resp: boolean) => {
        return resp;
      }))
  }

  getDettaglioOrdine(isTeamView: boolean,idOrdine: number, getClosed: boolean): Observable<ServiceRespone> {
    let url = msConfig['ms-ordini'] + AppConstants.PATH_ORDINI + '/' + idOrdine;
    let params: any = {};
    params.isTeamView = isTeamView;
    params.getClosed = getClosed;
    return this.http
    .get(url, { params })
    .pipe(map((resp: ServiceRespone) => {
      let ordine;
      ordine = resp;
      return ordine;
    }),catchError(CommonUtils.errorHandler))
  }

  getTotaleOrdini(isTeamView:boolean, ordiniChiusi:Boolean, fornitore ?:string, codiceOrdine?: string, stato?:StatoOrdine,  materiale?:string, dataInizio ?: Date, dataFine ?: Date, filtroIspettore? : Utente, hashtag?:string, posizioniCollaudo?:boolean):Observable<ServiceRespone> {
    let url = msConfig['ms-ordini'] + AppConstants.PATH_TOTALE_ORDINI;
    let params: any = {};
    params.isTeamView = isTeamView
    params=CommonUtils.containsParam(params,filtroIspettore?.id,"idIspettore")
    params=CommonUtils.containsParam(params,fornitore,"fornitore")
    params=CommonUtils.containsParam(params,hashtag,"hashtag")
    params=CommonUtils.containsParam(params,posizioniCollaudo,"collaudo")
    params=CommonUtils.containsParam(params,codiceOrdine?.trim(),"codiceOrdine")
    params=CommonUtils.containsParam(params,stato,"stato")
    params=CommonUtils.containsParam(params,materiale,"materiale")
    params=CommonUtils.containsParam(params,ordiniChiusi,"ordiniChiusi")
    if(dataInizio != null){
      params=CommonUtils.containsParam(params,CommonUtils.formatDate(dataInizio),"dataInizio")
    }
    if(dataFine != null){
      params=CommonUtils.containsParam(params,CommonUtils.formatDate(dataFine),"dataFine")
    }
    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let ordini;
        ordini = resp;
        return ordini;
      }),catchError(CommonUtils.errorHandler))

  }

  getOrdini(isTeamView: boolean,ordiniChiusi:Boolean, includePosizioni: boolean, first: number, length: number,fornitore ?:string, codiceOrdine?: string, stato?:StatoOrdine,  materiale?:string, dataInizio ?: Date, dataFine ?: Date, ordinamentoPer? : string, direzione? :boolean, filtroIspettore? : Utente, hashtag?:string, posizioniCollaudo?:boolean): Observable<ServiceRespone> {

    let url = msConfig['ms-ordini'] + AppConstants.PATH_ORDINI;
    let params: any = {};
    params.isTeamView = isTeamView
    params.includePosizioni = includePosizioni
    params.first = first
    params.length = length
    params=CommonUtils.containsParam(params,filtroIspettore?.id,"idIspettore")
    params=CommonUtils.containsParam(params,fornitore,"fornitore")
    params=CommonUtils.containsParam(params,hashtag,"hashtag")
    params=CommonUtils.containsParam(params,posizioniCollaudo,"collaudo")
    params=CommonUtils.containsParam(params,codiceOrdine?.trim(),"codiceOrdine")
    params=CommonUtils.containsParam(params,stato,"stato")
    params=CommonUtils.containsParam(params,materiale,"materiale")
    params=CommonUtils.containsParam(params,ordinamentoPer,"ordinamentoPer")
    params=CommonUtils.containsParam(params,direzione,"direzione")
    params=CommonUtils.containsParam(params,ordiniChiusi,"ordiniChiusi")
    if(dataInizio != null){
      params=CommonUtils.containsParam(params,CommonUtils.formatDate(dataInizio),"dataInizio")
    }
    if(dataFine != null){
      params=CommonUtils.containsParam(params,CommonUtils.formatDate(dataFine),"dataFine")
    }


    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let ordini;
        ordini = resp;
        return ordini;
      }))


  }

  deleteFasi(idPosizioni: number[]): Observable<ServiceRespone> {
    let url = msConfig['ms-ordini'] + AppConstants.PATH_POSIZIONI + '/fasi' ;
    let params: any = {};
    params.idPosizioni = idPosizioni
    return this.http
      .delete(url, params = {params})
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }

  evadiPosizione(idPosizione: number): Observable<ServiceRespone> {
    let url = msConfig['ms-ordini'] + AppConstants.PATH_POSIZIONI + '/' + idPosizione + AppConstants.PATH_EVADI_POSIZIONE
    let params: any = {};
    params.isManuale = true;

    return this.http
      .put(url,{}, params = {params})
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }

  isSvincoloApertoSuPosizione(idPosizione: number): Observable<ServiceRespone> {
    let url = msConfig['ms-svincoli'] + AppConstants.PATH_IS_SVINCOLI_APERTI;
    let params: any = {};
    params.idPosizione = idPosizione
    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }

  getListFasiByNumeroOrdine(numeroOrdine: string): Observable<ServiceRespone> {
    let url = msConfig['ms-ordini'] +  AppConstants.PATH_GET_LIST_FASI_BY_NUMERO_ORDINE;
    let params: any = {};
    params.numeroOrdine = numeroOrdine
    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }

}
